import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { FlexBetween, FlexCenter } from '../../global/commonStyle';

export const MainCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--space-12) var(--space-24);
  gap: var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-0) var(--space-20);
  `)}
`;

export const TopSection = styled.div`
  width: 100%;
  ${FlexBetween}
`;

export const TopRightSection = styled.div`
  ${FlexCenter}
  gap: var(--space-10);
`;

export const Logo = styled.div`
  ${FlexCenter}
`;

export const Label = styled.p`
  ${Typography.body_md_semibold}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

export const ButtonSection = styled.div`
  ${FlexCenter}
  gap: var(--space-10);
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-8);
`;

export const Title = styled.div`
  ${Typography.body_md}
  color:var(--text-primary);
`;
